import * as moment from "moment";

export const dateFormat = "DD-MM-YYYY";
export const eventDateFormatFull = "DD-MM-YYYY HH:00:00";
export const monthYearFormat = "MM-YYYY";
export const dayFormat = "DD";

export class CalculateDataModel {
  sum: number;
  label: string;
}

export class ChartConfigDatasetModel {
  __key: number;
  data: any[];
  _originalDataFromApiRest: any[];
  originalData: any[];
  label?: string;
  yAxisID: string;
  spanGaps: boolean;
  lineTension?: number;
  pointHoverRadius?: number;
  radius?: number;
  borderDash?: number[];
  pointRadius?: any[];
  pointBackgroundColor?: any[];
  pointBorderColor?: any[];
  pointBorderWidth?: any[];
  backgroundColor?: any[];
  borderColor?: any[];
  borderWidth?: any[];
  fill?: any[];
  showLine?: any[];
}

export class ChartConfigModel {
  private _published_at = null;
  private _id: number;
  private _threshold = 0;
  private _showThreshold = false;
  for: "joboffers" | "events" | "posts" | "polls" | "total" | "webinar";
  ctrLabel: string;
  cumulative: boolean;
  datasets: ChartConfigDatasetModel[];
  options: any;
  legend: boolean;
  type: string;
  hover: (args?: any) => any;
  click: (args?: any) => any;
  daysBehind: number;
  private _year: number;
  bucketSize: number;
  title: string;
  private _monthly_percentage = 0;
  sums: { [key: number]: CalculateDataModel };
  ctr: CalculateDataModel;
  navigate_label: string;
  subset: number;
  colors: any[];

  public brandPrimary = "#fe4d01";
  public brandSuccess = "#00CD89";

  private _ready: boolean;
  private _momentStart: moment.Moment;
  private _momentEnd: moment.Moment;
  private _start: string;
  private _end: string;
  private _labels: string[];

  set published_at(value: string) {
    this._published_at = value;
    // if (!this.isYearGraph) {
    //   this.start = value;
    // }
  }

  get published_at(): string {
    return this._published_at;
  }

  get retreiveCorrectDateFormat(): string {
    return this.isForEvents ? eventDateFormatFull : dateFormat;
  }

  get retreiveCorrectMomentAddParam(): "month" | "day" | "hour" {
    // return this.isForEvents ? 'hour' : 'day';
    return this.isForEvents ? "hour" : this.isYearGraph ? "month" : "day";
  }

  set start(value: string) {
    this._start = value;
    this._momentStart = moment(this._start, this.retreiveCorrectDateFormat);
  }

  get start(): string {
    return this._start;
  }

  get momentStart(): moment.Moment {
    return this._momentStart;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get hasId(): boolean {
    return !!this._id;
  }

  get year(): number {
    return this._year;
  }

  set year(value: number) {
    this._year = value;
  }

  get hasYear(): boolean {
    return !!this._year;
  }

  get isYearGraph(): boolean {
    return (
      this._year &&
      ((this._year === moment().year() && this.daysBehind === 9999) ||
        moment().year() > this._year)
    );
  }

  set end(value: string) {
    const endDate = value;
    // if (this.year === moment().year()) {
    //   endDate = moment().format(this.retreiveCorrectDateFormat);
    // }
    this._end = endDate;
    this._momentEnd = moment(this._end, this.retreiveCorrectDateFormat);
  }

  get end(): string {
    return this._end;
  }

  get momentEnd(): moment.Moment {
    return this._momentEnd;
  }

  set ready(value: boolean) {
    this._ready = value;
  }

  get ready(): boolean {
    return this._ready;
  }

  get threshold(): number {
    return this._threshold;
  }

  set threshold(value: number) {
    this._threshold = value;
  }

  get monthly_percentage(): number {
    return this._monthly_percentage;
  }

  set monthly_percentage(value: number) {
    this._monthly_percentage = value;
  }

  get showThreshold(): boolean {
    return this._showThreshold;
  }

  set showThreshold(value: boolean) {
    this._showThreshold = value;
  }

  get hasThreshold(): boolean {
    return this.threshold > 0 && this.daysBehind === 30 && this.showThreshold;
  }

  get isForEvents(): boolean {
    return this.for === "events";
  }

  get isForPosts(): boolean {
    return this.for === "posts";
  }

  getCorrectHour(v: number): number {
    return v + 2;
  }

  constructor(
    subset: number,
    daysBehind: number = 30,
    year: number = null,
    bucketSize: number = 1,
    cumulative = false
  ) {
    this.reset(subset, daysBehind, year, bucketSize, cumulative);
  }

  /**
   * return true if no data from rest api
   */
  get datasetsAreEmpty(): boolean {
    let ret = true;
    this.datasets.forEach((ds) => {
      if (Object.keys(ds.originalData).length > 0) {
        ret = false;
      }
    });

    return ret;
  }

  reset(
    subset: number,
    daysBehind: number = 30,
    year: number = null,
    bucketSize: number = 1,
    cumulative = false
  ) {
    this.cumulative = cumulative;
    this.sums = null;
    this.daysBehind = daysBehind;
    this.bucketSize = bucketSize;
    this._ready = false;
    this.type = "line";
    this.legend = false;
    this.subset = subset;
    this.year = year;
    this.ctr = {
      sum: 0,
      label: "CTR",
    };
    this.colors = [
      {
        // brandInfo
        backgroundColor: "transparent",
        borderColor: this.brandPrimary,
        pointHoverBackgroundColor: "#fff",
        pointBackgroundColor: this.brandPrimary,
      },
      {
        // brandSuccess
        backgroundColor: "transparent",
        borderColor: this.brandSuccess,
        pointHoverBackgroundColor: "#fff",
        pointBackgroundColor: this.brandSuccess,
      },
      {
        backgroundColor: "transparent",
        borderColor: "rgba(200, 200, 200, .7)",
        pointHoverBackgroundColor: "#fff",
      },
    ];
    this.options = {
      responsive: true,
      maintainAspectRatio: false,
      cubicInterpolationMode: "default",
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 10,
          bottom: 0,
        },
      },
      tooltips: {
        mode: "index",
        intersect: false,
      },
      hover: {
        mode: "index",
        intersect: false,
      },
      scales: {
        xAxes: [
          {
            drawBorder: true,
            gridLines: {
              drawOnChartArea: true,
            },
            ticks: {
              fontSize: 16,
              padding: 20,
              autoSkip: true,
              callback: (value: any, index: number, values: any) => {
                let newLabel: string = value;

                if (this.isForEvents) {
                  const temp = moment(newLabel, eventDateFormatFull);
                  newLabel = `${temp.format("DD MMM HH:mm")}-${temp
                    .add(this.retreiveCorrectMomentAddParam, this.bucketSize)
                    .format("HH:mm")}`;
                } else if (this.isYearGraph) {
                  //  && !this.hasId
                  newLabel = moment(value, dateFormat).format("MMM YYYY");
                } else if (
                  (this.bucketSize === 1 &&
                    moment().format(dateFormat) === value) ||
                  moment().isBetween(
                    moment(value, dateFormat),
                    moment(value, dateFormat).add("day", this.bucketSize)
                  )
                ) {
                  newLabel = `* ${newLabel}`;
                }

                return newLabel;
              },
            },
          },
        ],
        yAxes: [
          {
            type: "linear",
            maxBarThickness: 100,
            gridLines: {
              display: false,
              drawOnChartArea: true,
            },
            display: this.subset === 2 || this.subset === 0,
            position: "right",
            id: "y-axis-2",
            scaleLabel: {
              display: true,
              labelString:
                this.datasets && this.datasets[1] && this.datasets[1].label
                  ? this.datasets[1].label
                  : "",
              fontColor: this.brandSuccess,
              fontSize: 18,
            },
            ticks: {
              autoSkip: true,
              padding: 10,
              beginAtZero: true,
              callback: function (value: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              },
            },
          },
          {
            type: "linear",
            gridLines: {
              display: false,
              drawOnChartArea: true,
            },
            display: true,
            position: "left",
            id: "y-axis-1",
            scaleLabel: {
              display: true,
              labelString: "",
              fontColor: this.brandPrimary,
              fontSize: 18,
            },
            ticks: {
              autoSkip: true,
              padding: 10,
              beginAtZero: true,
              callback: function (value: any) {
                if (Math.floor(value) === value) {
                  return value;
                }
              },
            },
          },
        ],
      },
      elements: {
        line: {
          borderWidth: 2,
        },
        point: {
          radius: 5,
          hitRadius: 8,
          hoverRadius: 8,
          hoverBorderWidth: 3,
        },
      },
      legend: {
        display: false,
      },
    };
    this.labels = [];
    this.hover = ($event) => {};
    this.click = ($event) => {};
  }

  formatAndExcludeItemsNotInRange(data: any[]): any[] {
    let ret = [];
    if (this.isForEvents) {
      data.forEach((item) => {
        let itemDate = moment(item.date, dateFormat);
        itemDate = moment(
          `${itemDate.format(dateFormat)} ${this.getCorrectHour(
            item.hour
          )}:00:00`,
          this.retreiveCorrectDateFormat
        );
        if (itemDate.isBetween(this.momentStart, this.momentEnd, null, "[]")) {
          ret.push({
            date: itemDate.format(this.retreiveCorrectDateFormat),
            count: item.count,
          });
        }
      });
    } else if (this.isYearGraph) {
      // && !this.hasId
      data.forEach((item) => {
        const itemDate = moment(`01-${item.month}-${item.year}`, dateFormat);
        // itemDate = moment(`${itemDate.format(dateFormat)} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
        // if (itemDate.isBetween(this.momentStart, this.momentEnd, null, '[]')) {
        ret.push({
          date: itemDate.format(this.retreiveCorrectDateFormat),
          count: item.count,
        });
        // }
      });
      // else if (this.isForPosts && this.published_at) {
      //   const startDate: moment.Moment =
      //      this._published_at ? moment(this._published_at, this.retreiveCorrectDateFormat) : this.momentStart;
      //   data.forEach(item => {
      //     const itemDate = moment(item.date, dateFormat);
      //     // itemDate = moment(`${itemDate.format(dateFormat)} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
      //     if (itemDate.isBetween(startDate, this.momentEnd, null, '[]')) {
      //       ret.push({
      //         date: itemDate.format(this.retreiveCorrectDateFormat),
      //         count: item.count
      //       })
      //     }
      //   });
      // }
    } else {
      ret = data;
    }
    return ret;
  }

  /**
   *
   * @param key
   * @param label
   * @param data
   * @param yAxisID
   */
  prepareDataset(
    key: number,
    label: string,
    data: any[],
    yAxisID = "y-axis-1"
  ) {
    if (!this.datasets) {
      this.datasets = [];
    }

    const _ds: ChartConfigDatasetModel = {
      __key: key,
      // deep cloning data from rest api
      _originalDataFromApiRest: JSON.parse(JSON.stringify(data)),
      originalData: JSON.parse(
        JSON.stringify(this.formatAndExcludeItemsNotInRange(data))
      ),
      data: this.formatAndExcludeItemsNotInRange(data),
      label: label,
      yAxisID: yAxisID,
      spanGaps: true,
      lineTension: 0.4,
    };

    this.datasets.push(_ds);

    if (!this.labels || (this.labels && this.labels.length === 0)) {
      this.labels = this.calculateLabels();
    }

    this.calculateLabelsDatesArray(key);

    this.labelStringScaleLabel(label, yAxisID);

    if (!this.sums) {
      this.sums = {};
    }

    if (!this.sums[key]) {
      this.sums[key] = { sum: 0, label: "" };
    }

    this.sums[key].sum = this.sumCounters(
      this.datasets.find((dS) => dS.__key === key).originalData
    );
    this.sums[key].label = label;

    this.calculateCtr();

    //
    this.datasets.sort((a, b) => (a.__key < b.__key ? -1 : 1));

    // specific for articvle detail
    // if published at, skipping values before this date
    // if (this.isForPosts && this.hasId && this.published_at) {
    //   this.labels = this.labels.filter(_label => moment(_label).isAfter(moment(this.published_at)));
    //   this.datasets.forEach(dataset => {
    //     dataset.data.
    //   });
    // }

    if (this.hasThreshold && !this.datasets.find((dS) => dS.__key === 2)) {
      this.calculateMontlyPercentage();

      this.datasets.push({
        __key: 2,
        _originalDataFromApiRest: new Array(this.labels.length).fill(
          this.threshold
        ),
        originalData: new Array(this.labels.length).fill(this.threshold),
        data: new Array(this.labels.length).fill(this.threshold),
        label: "Monthly target",
        yAxisID: "y-axis-1",
        spanGaps: true,
        pointHoverRadius: 0,
        radius: 0,
        borderDash: [10, 5],
      });
    }
  }

  /**
   * sets the label on left and right side of the graph
   * @param label label to show
   * @param key axes id
   */
  labelStringScaleLabel(label: string, key: string) {
    const optionScale = this.options.scales.yAxes.find((ele) => ele.id === key);

    if (optionScale) {
      optionScale.scaleLabel.labelString = label;
    }
  }

  /**
   * calculates counters sum given a dataset
   * @param data
   */
  sumCounters(data: Object): number {
    let sum = 0;
    // return data.reduce((a, b) => a.count + b.conut, 0);
    if (Object.keys(data).length === 0) {
      return 0;
    }

    Object.keys(data).forEach((index) => (sum += data[index].count));
    return sum;
  }

  get labels(): string[] {
    return this._labels;
  }

  set labels(labels: string[]) {
    this._labels = labels;
  }

  /**
   * method which return all "label dates" on graph "x axes"
   */
  calculateLabels(): string[] {
    let allDates: string[] = [];
    const mIndexDate = this.momentStart;
    let endDate: moment.Moment = this.momentEnd;
    if (this.year === moment().years() && this.isYearGraph) {
      endDate = moment(
        `01-${moment().months() + 1}-${moment().years()}`,
        this.retreiveCorrectDateFormat
      );
    }
    // creating all dates array based on start date, end date and bucketSize
    while (mIndexDate.isSameOrBefore(endDate)) {
      allDates.push(mIndexDate.format(this.retreiveCorrectDateFormat));
      // adding bucketSize as number of days / hours
      mIndexDate.add(this.retreiveCorrectMomentAddParam, this.bucketSize);
    }

    // if (this.isForPosts && !this.isYearGraph && this.published_at) {
    //   allDates = allDates.filter((_label) => {
    //     return moment(_label, this.retreiveCorrectDateFormat).isSameOrAfter(moment(this.published_at, this.retreiveCorrectDateFormat))
    //   });
    // }

    if (this.year !== moment().years() && this.isYearGraph) {
      allDates = allDates.slice(0, allDates.length - 1);
    }

    return allDates;
    // return allDates.slice(0, allDates.length - 1);
  }

  /**
   *
   * @param key
   */
  calculateLabelsDatesArray(key: number) {
    // selecting correct dataset
    const currentDataset = this.datasets.find((ds) => ds.__key === key);
    //
    const pushData = (date: moment.Moment, count: number): void => {
      currentDataset.data.push({
        date: date.format(this.retreiveCorrectDateFormat),
        count: count,
      });
    };

    const checkIfDateIsMissing = (xAxesLabel: moment.Moment): boolean => {
      // if (!this.isForEvents) {
      return !currentDataset.data.find(
        (item) =>
          item.date === xAxesLabel.format(this.retreiveCorrectDateFormat)
      );
      // } else {
      //   return !currentDataset.data.find(
      //     item => {
      //       const calcDate =
      //         moment(`${item.date} ${this.getCorrectHour(item.hour)}:00:00`, this.retreiveCorrectDateFormat);
      //       // console.log(item.date, moment(item.date, eventDateFormat).format(dateFormat));
      //       // console.log('item.date: ' + item.date, 'item.hour: ' + item.hour); // , calcDate, xAxesLabel
      //       // console.log(calcDate.isBetween(this.momentStart, this.momentEnd, 'hour', '()'), calcDate === xAxesLabel);
      //       return calcDate === xAxesLabel;
      //     }
      //   )
      // }
    };
    // looping over all "x" graph labels => array of dates,
    // if the dataset is missing a specific date, this method will fill this date with a count = 0
    this.labels.forEach((label) => {
      const momentDate = moment(label, this.retreiveCorrectDateFormat);
      // not event graph
      if (
        checkIfDateIsMissing(momentDate)
        // && (!this.isYearGraph || this.isYearGraph && this.year !== moment().year()
        // !currentDataset.data.find(
        //   item => item.date === momentDate.format(dateFormat)
        // )
      ) {
        pushData(momentDate, 0);
        // currentDataset.data.push({
        //   date: momentDate.format(dateFormat),
        //   count: 0
        // });
      }
    });

    // number array which will contains all counters data
    const counters: number[] = [];
    // sorting
    if (!this.isForEvents) {
      currentDataset.data.sort(this.compare);
    } else {
      currentDataset.data.sort(this.compareEvent);
    }

    // populating number array
    currentDataset.data.forEach((ele, index) => {
      if (this.cumulative && index) {
        ele.count += currentDataset.data[index - 1].count;
      }
      counters.push(ele.count);
    });
    // assing number array to data so can be displayed on the graph
    currentDataset.data = counters;
  }

  /**
   * !!! maybe to remove
   * @param date
   */
  private _retrieveMomentDate(date: string): moment.Moment {
    return moment(date, dateFormat);
  }

  getFormattedDate(value: Date): string {
    return moment(value).format(this.retreiveCorrectDateFormat) || null;
  }

  compareEvent(a, b) {
    const _a = moment(a.date, eventDateFormatFull);
    const _b = moment(b.date, eventDateFormatFull);
    const isAfter = _a.isAfter(_b);
    if (!isAfter) {
      return -1;
    }
    if (isAfter) {
      return 1;
    }
    return 0;
  }

  compare(a, b) {
    const _a = moment(a.date, dateFormat);
    const _b = moment(b.date, dateFormat);
    const isAfter = _a.isAfter(_b);
    if (!isAfter) {
      return -1;
    }
    if (isAfter) {
      return 1;
    }
    return 0;
  }

  calculateCtr(): void {
    if (this.subset === 0) {
      if (
        Object.keys(this.sums).length === 2 &&
        this.sums[0].sum < this.sums[1].sum
      ) {
        this.ctr.sum = Math.floor((this.sums[0].sum / this.sums[1].sum) * 100);
      }
    }
  }

  calculateMontlyPercentage(): void {
    if (Object.keys(this.sums).length > 0 && this.sums[0]) {
      this.monthly_percentage = Math.floor(
        ((this.sums[0].sum - this.threshold) * 100) / this.threshold
      );
    }
  }
}
